import o from"styled-components";import{COLORS as r}from"../../../../../constants/Theme.js";const t=o.div`
	background: ${r.surface.standard};
	border-left: ${o=>"2.0"===o.version?.5:1}px solid
		${r.stroke.primary};
	width: 50%;
`;export{t as DescriptionContainer};
